import AccordionCustom from "@components/Accordion/AccordionCustom";
import RelatedCaseStudies from "@components/CaseStudyComponents/RelatedCaseStudies";
import GenerateLinksHeader from "@components/LandingPageComponents/GenerateLinksHeader";
import NewLayout from "@components/new-ui/Layout";
import WhyGallaboxComponent from "@components/WhyGallaboxComponent";
import ShortUrl from "@components/shortURL";
import YellowCTAhref from "@components/yellowCTAhref";
import Head from "next/head";
import link from "public/link-connector.png";
import icon1 from "public/link-icon-1.png";
import icon2 from "public/link-icon-2.png";
import icon3 from "public/link-icon-3.png";
import React, { useRef } from "react";
import schema from "@components/faqSchema/whatsapp-link-generator-faqSchema.json";

const scriptText = JSON.stringify(schema, null, 2);

const RELATED_CASE_STUDIES = [
    {
        id: 2,
        bannerimg: "https://assets.gallabox.com/gb-home/hugg/hugg-og.png",
        tag: "",
        title: "Maximizing Conversions and Streamlining Support: Hugg's Transformation with Gallabox",
        link: "/case-study/hugg",
        description: "Here's the awe-inspiring tale of how Hugg boosted efficiency, enhanced customer support, and multiplied conversion rates with Gallabox.",
    },
    {
        id: 1,
        bannerimg: "https://assets.gallabox.com/gb-home/qatar-insurance-company/qatar-og.png",
        tag: "",
        title: "How Qatar Insurance Company Doubled Lead Generation with Gallabox",
        link: "/case-study/qatar-insurance-company",
        description: "Here's the awe-inspiring tale of how Qatar Insurance Company boosted lead generation, customer satisfaction, and automated responses with Gallabox.",
    },
];

const faq = [
    {
        question: "What does a WhatsApp link look like?",
        answer: "A WhatsApp link looks like this: wame.pro/1hatv3 ",
    },
    {
        question: "What happens when someone clicks on the WhatsApp link?",
        answer: "When someone clicks on the WhatsApp link, it will open a chat window with your WhatsApp Business number. They can then send you a message directly.",
    },
    {
        question: "Is there a fee for creating a WhatsApp link?",
        answer: "No, there is no fee for creating a WhatsApp link with Gallabox",
    },
    {
        question: "Are there any limitations when using this tool to create a WhatsApp link?",
        answer: "No, there are no limitations when you use Gallabox to create a WhatsApp link.",
    },
    {
        question: "How do SMB owners benefit from creating WhatsApp links?",
        answer: "SMB owners can benefit from creating WhatsApp links by improving engagement, increasing sales, and streamlining communication with customers.",
    },
    {
        question: "What’s the difference between a WhatsApp link and a WhatsApp QR code?",
        answer: "A WhatsApp link is a direct link to your WhatsApp Business number, while a WhatsApp QR code is a scannable code that can be used to access your WhatsApp Business number.",
    },
    {
        question: "How to use WhatsApp click-to-chat links on Instagram?",
        answer: "To use WhatsApp click-to-chat links on Instagram, simply add the link to your Instagram bio or post and encourage followers to click on it to reach your WhatsApp Business number",
    },
];

const WhatsappLink: React.FC = () => {
    const shortUrlRef = useRef<HTMLDivElement>(null);

    const handleScrollToShortUrl = () => {
        if (shortUrlRef && shortUrlRef.current) {
            shortUrlRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <NewLayout
            title="Free WhatsApp Link Generator to Create Chat Links Now!"
            description="Use a FREE WhatsApp Link Generator to make your WhatsApp Business details more accessible to potential and future customers to drive engagement and revenue."
            canonical="https://gallabox.com/whatsapp-link-generator"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/whatsapp-link-gen/og.png" }}
            schema={{
                heroOrOgImageAlt: "whatsapp-link-generator-image",
                heroOrOgImageDescription:
                    "Boost your sales and build meaningful connections using Gallabox's WhatsApp Link Generator. Increase customer satisfaction and improve business impact by giving your customers a direct line to reach you!",
                heroOrOgImageUrl: "https://assets.gallabox.com/gb-home/whatsapp-link-gen/header-new.png",
                softwareFeatureName: "whatsapp-link-generator",
                faq: faq,
            }}
        >
            <Head>
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: scriptText }} />
            </Head>
            <GenerateLinksHeader
                pageTitle="WhatsApp Link Generator"
                mainTitle="Free WhatsApp Link Generator to Connect with Your Customers Instantly"
                description="Boost your sales and build meaningful connections using Gallabox's WhatsApp Link Generator. Increase customer satisfaction and improve business impact by giving your customers a direct line to reach you!"
                imageUrl="https://assets.gallabox.com/gb-home/whatsapp-link-gen/header-new.png"
                scrollHandler={handleScrollToShortUrl}
                noSection
            />

            <div className=" mx-auto flex lg:flex-row flex-col w-full pb-8 pt-8" style={{ maxWidth: "1200px" }}>
                <div className="lg:order-2 order-1 lg:w-2/3 w-full lg:text-left text-center lg:px-0 px-2">
                    <h2 className="lg:text-3xl text-xl  font-bold pb-4  ">Why Use a WhatsApp Link Generator?</h2>
                    <div className="">
                        <p className="lg:text-lg text-base text-gray-600 pb-4">
                            A WhatsApp link generator can help you solve problems like missed opportunities, lost sales, and disengaged contacts by enabling customers and prospects
                            to easily reach you.
                        </p>
                        <div>
                            {" "}
                            <h3 className="lg:text-2xl text-xl  font-bold pb-4 ">Connect with People Instantly</h3>
                            <p className="lg:text-lg text-base  text-gray-600 pb-4 ">
                                In just three easy steps, you can create a direct link enabling individuals, who don&apos;t have your contact details, to initiate a dialogue on
                                WhatsApp Business.
                            </p>
                        </div>
                        <div>
                            {" "}
                            <h3 className="lg:text-2xl text-xl  font-bold pb-4 ">Streamline Your Operational Workflows</h3>
                            <p className="lg:text-lg text-base  text-gray-600 pb-4 ">
                                Level up your communication game, improve engagement, and enhance customer experience by allowing customers and potential clients to contact you
                                instantly.
                            </p>
                        </div>
                        <div>
                            {" "}
                            <h3 className="lg:text-2xl text-xl  font-bold pb-4 ">Attain Maximum Revenue Potential</h3>
                            <p className="lg:text-lg text-base text-gray-600 pb-4 ">
                                Unlock revenue growth opportunities, elevate your sales, and amplify your profit margins by tapping into the potential of personalised WhatsApp
                                business links.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="lg:order-1 order-2 lg:w-1/3 w-full">
                    <img src="https://gallabox-assets.s3.ap-south-1.amazonaws.com/gb-home/whatsapp-link-gen/section.png" alt="Advantages of using WhatsApp Link Generator" />
                </div>
            </div>

            <div className="flex flex-col items-center justify-center py-10" style={{ backgroundColor: "#F0FFF4" }}>
                <div className="lg:text-center text-left mb-8">
                    <h2 className="text-3xl font-bold lg:text-center text-left  ">How to Create WhatsApp Links for Free in 3 Simple Steps</h2>
                    <p className="text-lg lg:text-center text-left px-5">
                        Creating your personalized WhatsApp link using Gallabox is as simple as one-two-three, and here&apos;s how you do it:
                    </p>
                </div>
                <img src={link} className="lg:block hidden max-w-2xl mx-auto" alt="steps to create whatsapp link"></img>
                <div className="flex flex-col lg:flex-row justify-center lg:space-x-4">
                    <div className="w-80 h-40 border border-gray-300 rounded-lg flex flex-col items-center justify-center">
                        <img src={icon1} alt="Image 1" className=" lg:hidden block w-12 h-12 object-cover rounded-t-lg" />
                        <h2 className="text-lg font-bold my-2">Provide Your Contact Details</h2>
                        <p className="text-sm text-center">Enter your WhatsApp Business number into the Gallabox WhatsApp link generator</p>
                    </div>
                    <div className="w-80 h-40 border border-gray-300 rounded-lg flex flex-col items-center justify-center">
                        <img src={icon2} alt="Image 2" className=" lg:hidden block w-12 h-12 object-cover rounded-t-lg" />
                        <h2 className="text-lg font-bold my-2">Add a Personal Message</h2>
                        <p className="text-sm text-center">Write a unique message with your WhatsApp link to make it more personalise</p>
                    </div>
                    <div className="w-80 h-40 border border-gray-300 rounded-lg flex flex-col items-center justify-center">
                        <img src={icon3} alt="Image 3" className=" lg:hidden block w-12 h-12 object-cover rounded-t-lg" />
                        <h2 className="text-lg font-bold my-2">Create Custom WhatsApp Chat Link</h2>
                        <p className="text-sm text-center">Hit the &quot;Generate Link&quot; button to claim your unique WhatsApp chat link for FREE</p>
                    </div>
                </div>
            </div>

            <div ref={shortUrlRef}>
                <ShortUrl />
            </div>
            <WhyGallaboxComponent />

            <RelatedCaseStudies
                sectionTitle={<h3 className="text-4xl pb-6">Our Customer’s Success Is Our Success!</h3>}
                sectionDescription={
                    <p className="text-xl font-normal text-center text-gray-600">
                        <b className="font-bold">Over 1500+ Companies in 40+ countries</b> trust Gallabox to manage and automate their business conversations.
                    </p>
                }
                related={RELATED_CASE_STUDIES}
            />

            <YellowCTAhref
                buttonText="Get Started Today"
                customText={
                    <h3 className="text-2xl md:text-3xl font-bold text-yellow-800">
                        WhatsApp Links May Just Be Your Launchpad, Propel <br /> Your Business Forward With WhatsApp Automation
                    </h3>
                }
            />

            <section className="max-w-6xl py-4 mx-auto px-4">
                <div className="flex flex-col justify-center lg:gap-4 gap-2 items-center pb-6">
                    <h3 className="lg:text-4xl text-3xl text-center font-bold text-gray-700">
                        WhatsApp Business Link Generator:
                        <br /> Frequently Asked Questions
                    </h3>
                </div>
                <AccordionCustom title="WhatsApp Business Link Generator" items={faq} />
            </section>
        </NewLayout>
    );
};

export default WhatsappLink;
